"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Chat_1 = require("./components/Chat");
const LayoutController_1 = require("./context/LayoutController");
const useInfo_1 = require("./hooks/useInfo");
const App = () => {
    const info = (0, useInfo_1.useUserInfo)();
    if (info == null) {
        return null;
    }
    localStorage.setItem('info', JSON.stringify(info));
    return ((0, jsx_runtime_1.jsx)("main", { children: (0, jsx_runtime_1.jsx)(LayoutController_1.LayoutControlProvider, { children: (0, jsx_runtime_1.jsx)(Chat_1.GamingChat, { info: info }) }) }));
};
exports.default = App;
